<template>
  <span
    data-testid="permission-origin-badge"
    :data-origin="origin.kind"
    class="inline-flex items-center gap-1 whitespace-nowrap rounded-md border px-2 py-1 text-xs font-medium"
    :class="
      origin.kind === 'direct'
        ? 'border-primary10 bg-primary5 text-primary40'
        : 'border-purple-200 bg-purple-50 text-purple-700'
    "
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-4 w-4 flex-shrink-0"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path :d="origin.kind === 'direct' ? mdiAccount : mdiAccountGroup" fill="currentColor" />
    </svg>
    <span class="max-w-[140px] truncate">{{ label }}</span>
    <v-tooltip activator="parent" location="top">{{ tooltipText }}</v-tooltip>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { mdiAccount, mdiAccountGroup } from '@mdi/js'

import type { PermissionTreeOrigin } from '@/Network/Types/Responses/PermissionResponses'

import { getOriginTooltip } from '../utils'

const props = defineProps<{ origin: PermissionTreeOrigin }>()

const label = computed(() => {
  if (props.origin.kind === 'direct') return 'Direta'
  return props.origin.group_name ? `Grupo · ${props.origin.group_name}` : 'Grupo'
})

/** "Direta — {relation}" ou "Grupo {nome} — {relation}", com sufixo "(herdada)". */
const tooltipText = computed(() => getOriginTooltip(props.origin))
</script>
